// extracted by mini-css-extract-plugin
module.exports = {"BadgeSection":"BadgeSection_BadgeSection__oIJvr"};